import React, { useState, useEffect } from 'react';
import './style.css';
import Logo from '../../assets/LOGOTIPO.png';
import User from '../../assets/User.png';
import { NavLink } from "react-router-dom";
import { useAppContext } from '../../context/AppContext';

const Sidebar = () => {
    const [activeMenu, setActiveMenu] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
    const { companies, selectedCompany, setSelectedCompany } = useAppContext();

    const toggleMenu = (menu) => {
        setActiveMenu(activeMenu === menu ? null : menu);
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const handleCompanyChange = (event) => {
        setSelectedCompany(event.target.value); // Armazena "null" para todas as empresas
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setSidebarOpen(false);
            } else {
                setSidebarOpen(true);
            }
        };

        //console.log('Empresas: ' + JSON.stringify(companies));

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div >
            <div className="hamburger" onClick={toggleSidebar}>
                <i className="fa-solid fa-bars"></i> {/* Ícone de hambúrguer */}
            </div>
            <div className={`d-flex flex-column justify-content-between menu-container sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
                <div>
                    <div className="logo-details">
                        {(() => {
                            const empresaSelecionada = companies.find(c => c.codempresa === Number(selectedCompany));
                            const hasFoto = !!empresaSelecionada?.foto; // true se tiver foto válida

                            return (
                                <>
                                    <img
                                        className={hasFoto ? "Logo" : "Logo2"}
                                        src={empresaSelecionada?.foto || Logo}
                                        alt="logo"
                                    />
                                    <span className="logo-name">MetaGame</span>
                                </>
                            );
                        })()}
                    </div>                    

                    <div className="menu-item" onClick={() => toggleMenu('menu0')}>
                        <NavLink to="/principal" className="dropdown-item">
                            Dashboard
                        </NavLink>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu1')}>
                        <div className='menu-item-texto'>Cadastros
                            <i className={`bx ${activeMenu === 'menu1' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu1' ? 'active' : ''}`}>
                            <div className="submenu-item" onClick={() => toggleMenu('menu11')}>
                                <NavLink to="/setor" className="dropdown-item">
                                    Setor
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu12')}>
                                <NavLink to="/funcao" className="dropdown-item">
                                    Função
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu13')}>
                                <NavLink to="/colaborador" className="dropdown-item">
                                    Profissional
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu14')}>
                                <NavLink to="/equipe" className="dropdown-item">
                                    Equipe
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu15')}>
                                <NavLink to="/titulo" className="dropdown-item">
                                    Prêmio
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu16')}>
                                <NavLink to="/desafio" className="dropdown-item">
                                    Desafio
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu17')}>
                                <NavLink to="/checklist" className="dropdown-item">
                                    Checklist
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu18')}>
                                <NavLink to="/lojinha" className="dropdown-item">
                                    Lojinha
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu19')}>
                                <NavLink to="/evento" className="dropdown-item">
                                    Evento
                                </NavLink>
                            </div>

                            <div className="submenu-item" onClick={() => toggleMenu('menu110')}>
                                <NavLink to="/orcamento" className="dropdown-item">
                                    Orçamento
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu2')}>
                        <div className='menu-item-texto'>Operações
                            <i className={`bx ${activeMenu === 'menu2' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu2' ? 'active' : ''}`}>
                            <div className="submenu-item">
                                <NavLink to="/ope/ajusteponto" className="dropdown-item">
                                    Ajuste de Ponto
                                </NavLink>
                            </div>

                            <div className="submenu-item">
                                <NavLink to="/ope/recebermissaodesafio" className="dropdown-item">
                                    Receber Missão/Desafio
                                </NavLink>
                            </div>

                            <div className="submenu-item">
                                <NavLink to="/ope/feedback" className="dropdown-item">
                                    Feedback
                                </NavLink>
                            </div>

                            <div className="submenu-item">
                                <NavLink to="/ope/checklist" className="dropdown-item">
                                    Tarefas Finalizadas
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu3')}>
                        <div className='menu-item-texto'>Relatórios
                            <i className={`bx ${activeMenu === 'menu3' ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'}`}></i>
                        </div>

                        <div className={`submenu ${activeMenu === 'menu3' ? 'active' : ''}`}>
                            <div className="submenu-item">
                                <NavLink to="/rel/humor" className="dropdown-item">
                                    Humor
                                </NavLink>
                            </div>

                            <div className="submenu-item">
                                <NavLink to="/rel/ponto" className="dropdown-item">
                                    Ponto
                                </NavLink>
                            </div>

                            <div className="submenu-item">
                                <NavLink to="/rel/saldoponto" className="dropdown-item">
                                    Saldo de Ponto
                                </NavLink>
                            </div>

                            <div className="submenu-item">
                                <NavLink to="/rel/pontoerro" className="dropdown-item">
                                    Ponto com Erro
                                </NavLink>
                            </div>

                            <div className="submenu-item">
                                <NavLink to="/rel/checklist" className="dropdown-item">
                                    CheckList
                                </NavLink>
                            </div>
                        </div>
                    </div>

                    <div className="menu-item" onClick={() => toggleMenu('menu4')}>
                        <NavLink to="/configuracao" className="dropdown-item">
                            Configuração
                        </NavLink>
                    </div>


                </div>

                {/* Adicione mais menus conforme necessário */}

                <div className="profile-details">
                    <div className="profile-content">
                        <img src={User} alt="User" />
                    </div>
                    <div className="name-job">
                        <div className="profile-name">
                            {/* Contêiner para o select */}
                            <div className="select-container">
                                <select className="form-select sidebar-select" value={selectedCompany || '0'} onChange={handleCompanyChange}>
                                    <option value="0">Todas as empresas</option>
                                    {companies.map((company, index) => (
                                        <option key={index} value={company.codempresa}>{company.razaosocial}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="job">0.0.10.0</div>
                    </div>

                    <i className="bx bx-log-out"></i>
                </div>
            </div>

        </div>
    );
};

export default Sidebar;
